"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _definitions = require('../definitions');
var _mergeClassName = require('../../utils/mergeClassName'); var _mergeClassName2 = _interopRequireDefault(_mergeClassName);

const settingsSchema = null;

const component = {
  mixins: [_definitions.vueComponentMixin],
  computed: {
    finalClassName() {
      const props = this.$props;
      const settings = props.uiSettings;
      return _mergeClassName2.default.call(void 0, "ds-checkbox", props.ui.className, props.className);
    },

    FieldLabel() {
      return this.context.FieldLabel;
    }
  }
};

exports. default = component;
 const checkboxModule = {
  id: "checkbox",
  settingsSchema,
  hideLabel: true,
  component
}; exports.checkboxModule = checkboxModule;

;(function(options){
  var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.editValue,
            expression: "editValue"
          }
        ],
        class: _vm.finalClassName,
        style: _vm.ui.style,
        attrs: { id: _vm.inputId, type: "checkbox", disabled: _vm.readonly },
        domProps: {
          checked: Array.isArray(_vm.editValue)
            ? _vm._i(_vm.editValue, null) > -1
            : _vm.editValue
        },
        on: {
          change: function($event) {
            var $$a = _vm.editValue,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 && (_vm.editValue = $$a.concat([$$v]))
              } else {
                $$i > -1 &&
                  (_vm.editValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.editValue = $$c
            }
          }
        }
      }),
      _vm._v(" "),
      _vm.FieldLabel
        ? _c(_vm.FieldLabel, {
            tag: "component",
            attrs: {
              text: _vm.labelText,
              htmlFor: _vm.inputId,
              schema: _vm.schema
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true


  options.render = render
  options.staticRenderFns = staticRenderFns
  options._compiled = true
})(exports.default);
